import * as React from 'react';
import { isSellerFollowed, submitFollowSeller, submitUnfollowSeller } from '@/redux/modules/followSeller';
import { useDispatch, useSelector } from 'react-redux';
import FollowSellerButton from './FollowSellerButton';
import FollowSellerLink from './FollowSellerLink';
import { ModalContext } from '@/redux/modules/modal';
import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';

type Props = {
    button?: boolean;
    children?: React.ReactNode;
    className?: string;
    longText?: boolean;
    modalContext?: ModalContext;
    primaryWithSecondarySuccess?: boolean;
    secondary?: boolean;
    sellerId: number;
    small?: boolean;
};

const FollowSellerContainer = (props: Props) => {
    const {
        button = false,
        children,
        className,
        longText,
        primaryWithSecondarySuccess = false,
        secondary = false,
        sellerId,
        small = false,
    } = props;

    const modalContext: ModalContext = {
        id: sellerId,
        type: 'follow auctioneer',
    };

    const dispatch = useDispatch();
    const followed = useSelector((state) => isSellerFollowed(state, sellerId));

    const toggleFollowSeller = React.useCallback(() => {
        if (!followed) {
            dispatch(submitFollowSeller(sellerId));
        } else {
            dispatch(submitUnfollowSeller(sellerId));
        }
    }, [dispatch, followed, sellerId]);

    const content = button ? (
        <FollowSellerButton
            className={className}
            longText={longText}
            onClick={toggleFollowSeller}
            primaryWithSecondarySuccess={primaryWithSecondarySuccess}
            secondary={secondary}
            sellerId={sellerId}
            small={small}
        >
            {children}
        </FollowSellerButton>
    ) : (
        <FollowSellerLink onClick={toggleFollowSeller} sellerId={sellerId}>
            {children}
        </FollowSellerLink>
    );

    return (
        <ShouldLogInContainer modalContext={modalContext} requireLogin runFunction={toggleFollowSeller}>
            {content}
        </ShouldLogInContainer>
    );
};

export default FollowSellerContainer;
